module.exports = __webpack_public_path__ + "media/images/icons/user-f87d39949d2c43d5560007597e0b92f7.svg";